export const NX_PURGE_SERVICE_UUID = 'b38849bc-bd4a-483e-8383-19d2fc315eb4';
export const PING_SERVICE_UUID = '02928117-5f03-46a7-8184-eee14389d30e';
export const MEDIA_INFO_SERVICE_UUID = '78a7418f-b630-4b02-886a-674f63df4961';
export const MEZZ_PROXY_SERVICE_UUID = 'b48fe771-a347-4d46-88e2-c1eb505d1c09';
export const HASH_SERVICE_UUID = '30ec54e5-98dd-48a4-9773-972467128ffa';
export const MATTE_DETECTION_SERVICE_UUID = '3f2a6d14-0b7c-4a19-9e21-77c0de51aa01';
export const S3_RESTORE_SERVICE_UUID = '6b8e2c37-4d51-4f8a-b3c2-9a1e7f0d4c22';
export const NX_RAY_SERVICE_UUID = '2c7762b8-e0e7-4c4b-aeed-2fdbea60c41c';
export const S3_COPY_SERVICE_UUID = 'bad52278-1f4c-452f-9c29-fd54541cfd32';
